import { Award, Globe, Trophy } from 'lucide-react';
import SEO from '../components/SEO';

const awardPrograms = [
  {
    title: 'International Travel Awards',
    type: 'AWARDS',
    description: 'Honoring excellence in travel and tourism industry worldwide.',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/5j2fg0bv_International-Travel-Awards.jpg',
  },
  {
    title: 'International Restaurant Awards',
    type: 'AWARDS',
    description: 'Celebrating culinary excellence and outstanding dining experiences.',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/c5xedox8_International-Restaurant-Awards.jpg',
  },
  {
    title: 'International Spa & Beauty Awards',
    type: 'AWARDS',
    description: 'Recognizing the finest spas and beauty establishments globally.',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/optcoqoz_International-Spa-%26-Beauty-Awards.jpg',
  },
  {
    title: 'World Star Hotel Awards',
    type: 'AWARDS',
    description: 'Honoring exceptional hospitality and luxury accommodations.',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/7kz9f6r2_World-Star-Hotel-Awards.jpg',
  },
  {
    title: 'Arabian Best of Best Awards',
    type: 'AWARDS',
    description: 'Celebrating excellence across industries in the Arabian region.',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/kqq8r3lj_Arabian-Best-of-Best-Awards.jpg',
  },
  {
    title: 'Europe Best of Best Awards',
    type: 'AWARDS',
    description: 'Recognizing outstanding achievements across European businesses.',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/6ztcpbij_europe-best-of-best-awards.jpg',
  },
  {
    title: 'Asia Best of Best Awards',
    type: 'AWARDS',
    description: 'Honoring excellence and innovation across Asian markets.',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/x7n6vd58_asia-best-of-best-awards.jpg',
  },
  {
    title: 'Oceania Best of Best Awards',
    type: 'AWARDS',
    description: 'Celebrating top performers in the Oceania region.',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/6bkpwhsk_oceania-best-of-best-awards.jpg',
  },
  {
    title: 'America Best of Best Awards',
    type: 'AWARDS',
    description: 'Recognizing excellence across North and South America.',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/n1j3no56_america-best-of-best-awards.jpg',
  },
  {
    title: 'Africa Best of Best Awards',
    type: 'AWARDS',
    description: 'Honoring outstanding achievements across the African continent.',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/ukfap44k_africa-best-of-best-awards.jpg',
  },
  {
    title: 'UK Best of Best Awards',
    type: 'AWARDS',
    description: 'Celebrating excellence in business across the United Kingdom.',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/jnszlgyr_uk-best-of-best-awards.jpg',
  },
  {
    title: 'World Technology Awards',
    type: 'AWARDS',
    description: 'Recognizing innovation and excellence in technology sector.',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/0860w178_world-technology-awards.jpg',
  },
  {
    title: 'World Real Estate Excellence Awards',
    type: 'AWARDS',
    description: 'Honoring outstanding achievements in real estate industry.',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/brwgiu7i_World-Real-Estate-Excellence-Awards.jpg',
  },
  {
    title: 'World Beauty Awards',
    type: 'AWARDS',
    description: 'Celebrating excellence in beauty and cosmetics industry.',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/9rmv3cqj_world-beauty-awards.jpg',
  },
  {
    title: 'World CEO Awards',
    type: 'AWARDS',
    description: 'Recognizing visionary leadership and business excellence.',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/08cyfp9t_World-CEO-Awards.jpg',
  },
  {
    title: 'World GM Awards',
    type: 'AWARDS',
    description: 'Honoring exceptional general managers across industries.',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/86xuskp6_World-GM-Awards.jpg',
  },
  {
    title: 'Golden Entrepreneur Awards',
    type: 'AWARDS',
    description: 'Celebrating entrepreneurial spirit and business innovation.',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/dk09669w_Golden-Entrepreneur-Awards.jpg',
  },
  {
    title: 'Golden Women Awards',
    type: 'AWARDS',
    description: 'Honoring outstanding women leaders and achievers globally.',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/5q7tt4x3_Golden-Women-Awards.jpg',
  },
];

const expoSummit = [
  {
    title: 'World AI Expo',
    type: 'EXPO',
    description: 'Join global leaders in artificial intelligence and technology innovation.',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/ktw2sp3a_world-ai-expo.jpg',
  },
  {
    title: 'World Entrepreneur Investor Summit',
    type: 'SUMMIT',
    description: 'Connect with successful entrepreneurs and investors from around the world.',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/bf45yk6j_World-Entrepreneur-Investor-Summit.jpg',
  },
  {
    title: 'World Study Expo',
    type: 'EXPO',
    description: 'Explore global education opportunities and connect with leading institutions.',
    image: 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/m310kl6v_world-study-expo.jpg',
  },
];

const EventCard = ({ event, index, testIdPrefix }) => (
  <div
    data-testid={`${testIdPrefix}-${index}`}
    className="group bg-[#0a0a0a] border border-white/10 hover:border-[#D4AF37]/30 transition-all duration-500 overflow-hidden"
  >
    {/* Image */}
    <div className="relative h-56 overflow-hidden">
      <img
        src={event.image}
        alt={event.title}
        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
      
      {/* Type Badge */}
      <div className="absolute top-4 left-4">
        <span className="bg-[#D4AF37] text-black text-xs font-bold px-3 py-1.5 uppercase tracking-wider">
          {event.type}
        </span>
      </div>
    </div>

    {/* Content */}
    <div className="p-6">
      <h3 className="font-montserrat text-white text-xl italic mb-3">{event.title}</h3>
      <p className="font-google-sans text-[#A1A1AA] text-sm leading-relaxed">
        {event.description}
      </p>
    </div>
  </div>
);

export const EventsPage = () => {
  return (
    <main data-testid="events-page" className="pt-24 min-h-screen bg-[#0a0a0a]">
      <SEO 
        title="Our Events - International Awards, Expos & Summits"
        description="Explore Golden Tree Events' portfolio of 18+ international award programs, global exhibitions, AI expos, and business summits. CEO Awards, GM Awards, Travel Awards & more."
        keywords="international awards, business events Dubai, CEO awards, travel awards, AI expo, entrepreneur summit, hospitality awards, corporate events"
      />
      {/* Hero Section */}
      <section className="py-16 md:py-24 border-b border-white/10">
        <div className="w-full px-4 sm:px-8 lg:px-16">
          <div className="text-center">
            <p className="font-google-sans text-[#D4AF37] text-xs tracking-[0.3em] uppercase mb-4">Events & Ceremonies</p>
            <h1 className="font-montserrat text-4xl sm:text-5xl lg:text-6xl text-white mb-6">
              Our{' '}
              <span className="gradient-gold">Events</span>
            </h1>
            <p className="font-google-sans text-[#A1A1AA] text-lg max-w-2xl mx-auto">
              World-class award programs, expos, and summits celebrating excellence 
              and innovation across industries globally.
            </p>
          </div>
        </div>
      </section>

      {/* Award Programs Section - Card Design */}
      <section className="py-16">
        <div className="w-full px-4 sm:px-8 lg:px-16">
          <div className="flex items-center gap-4 mb-10">
            <div className="w-14 h-14 border border-[#D4AF37]/30 flex items-center justify-center">
              <Trophy className="w-6 h-6 text-[#D4AF37]" />
            </div>
            <h2 className="font-montserrat text-3xl sm:text-4xl text-white">
              Award <span className="gradient-gold">Programs</span>
            </h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {awardPrograms.map((event, index) => (
              <EventCard key={index} event={event} index={index} testIdPrefix="award-program" />
            ))}
          </div>
        </div>
      </section>

      {/* Expo & Summit Section - Card Design */}
      <section className="py-16 bg-[#121212]">
        <div className="w-full px-4 sm:px-8 lg:px-16">
          <div className="flex items-center gap-4 mb-10">
            <div className="w-14 h-14 border border-[#D4AF37]/30 flex items-center justify-center">
              <Globe className="w-6 h-6 text-[#D4AF37]" />
            </div>
            <h2 className="font-montserrat text-3xl sm:text-4xl text-white">
              Expo & <span className="gradient-gold">Summit</span>
            </h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {expoSummit.map((event, index) => (
              <EventCard key={index} event={event} index={index} testIdPrefix="expo-summit" />
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default EventsPage;
